"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const FlightOverviewWeb_1 = __importDefault(require("../common/FlightOverviewWeb"));
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const native_1 = require("@react-navigation/native");
const RequestOverviewWeb_1 = __importDefault(require("../common/RequestOverviewWeb"));
const myFlightsHelper_1 = require("../../services/myFlightsHelper");
const MyOfferOverviewWeb_1 = __importDefault(require("./MyOfferOverviewWeb"));
const MyFlightsListWeb = ({ activeTab, asAPilot, userDetails }) => {
    const [filteredFlightData, setFilteredFlightData] = (0, react_1.useState)([]);
    const flightData = (0, react_redux_1.useSelector)(selectors_1.getMyFlights);
    const offers = (0, react_redux_1.useSelector)(selectors_1.getMyOffers);
    (0, react_1.useEffect)(() => {
        setFilteredFlightData((0, myFlightsHelper_1.filterFlights)(flightData, offers, activeTab));
    }, [activeTab, asAPilot, flightData]);
    const navigation = (0, native_1.useNavigation)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: filteredFlightData.map((obj, index) => obj.type !== "FlightOffer" ?
            (obj.request ?
                (0, jsx_runtime_1.jsx)(RequestOverviewWeb_1.default, { flightData: obj, navigate: () => navigation.navigate("MyRequestDetails", { id: obj.id }) }, `request${index}`) :
                (0, jsx_runtime_1.jsx)(FlightOverviewWeb_1.default, { flightData: obj, asAPilot: asAPilot, navigate: () => navigation.navigate("MyFlightDetails", { id: obj.id }), userDetails: userDetails }, `flight${index}`)) :
            (0, jsx_runtime_1.jsx)(MyOfferOverviewWeb_1.default, { flightOffer: obj }, `offer${index}`)) }));
};
exports.default = MyFlightsListWeb;
